import angular from 'angular';
import constants from 'app/constants';
import {
  amDataService,
  amSharedModelService,
  loaderService,
  ssDialogService,
  userService,
} from 'app/services';
import { alerts } from 'app/components/global';
import editPreparationItemCategoryDialog from './dialog.editPreparationItemCategoryDialog';
import controller from './preparation-item-categories.controller';
import directive from './preparation-item-categories.directive';
import preparationItemCategory from './preparationItemCategory';


export default angular.module('app.components.advisory.auditTrail.preparationItemCategories', [
  alerts,
  amDataService,
  amSharedModelService,
  constants,
  editPreparationItemCategoryDialog,
  loaderService,
  preparationItemCategory,
  ssDialogService,
  userService,
])
  .directive('amPreparationItemCategories', directive)
  .controller('PreparationItemCategoriesController', controller)
  .name;

console.log('app.components.advisory.auditTrail.preparationItemCategories created');
